"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
exports.filter = filter;
exports.filterByAirline = filterByAirline;
exports.filterByAirport = filterByAirport;
exports.filterByFlexibility = filterByFlexibility;
exports.filterByHasBaggage = filterByHasBaggage;
exports.filterByInsuranceOnly = filterByInsuranceOnly;
exports.filterByMultiSelect = filterByMultiSelect;
exports.filterByNestedMultiSelect = filterByNestedMultiSelect;
exports.filterByPrice = filterByPrice;
exports.generateFilterId = generateFilterId;
exports.getDisplayPriceFilterState = getDisplayPriceFilterState;
exports.mergeFilterState = mergeFilterState;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _every2 = _interopRequireDefault(require("lodash/every"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _split3 = _interopRequireDefault(require("lodash/split"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _filterInitialize = _interopRequireWildcard(require("./filter-initialize.utils"));
var _filterParams = _interopRequireWildcard(require("./filter-params.utils"));
var _filterQuery = _interopRequireWildcard(require("./filter-query.utils"));
var _filterData = _interopRequireDefault(require("./filter-data.utils"));
var _filterCheck = _interopRequireDefault(require("./filter-check.utils"));
var _filterUpdate = _interopRequireDefault(require("./filter-update.utils"));
var _itinerary = require("./itinerary.utils");
var _filterApplied = _interopRequireWildcard(require("./filter-applied.utils"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function filter(flights, filtersParams) {
  return (0, _filter2.default)(flights, function (_ref) {
    var flightFilterParams = _ref.filterParams,
      flightFareFamilies = _ref.fareFamilies;
    return (0, _every2.default)(filtersParams, function (filterParams, filterKey) {
      switch (filterKey) {
        case 'airline':
          return filterByAirline(filterParams, flightFilterParams === null || flightFilterParams === void 0 ? void 0 : flightFilterParams.airline);
        case 'airport':
          return filterByAirport(filterParams, flightFilterParams === null || flightFilterParams === void 0 ? void 0 : flightFilterParams.airport);
        case 'price':
          return filterByPrice(filterParams, flightFilterParams === null || flightFilterParams === void 0 ? void 0 : flightFilterParams.price);
        case 'stop':
          return filterByMultiSelect(filterParams, flightFilterParams === null || flightFilterParams === void 0 ? void 0 : flightFilterParams.stop);
        case 'maxStop':
          return filterByMultiSelect(filterParams, flightFilterParams === null || flightFilterParams === void 0 ? void 0 : flightFilterParams.maxStop);
        case 'departureTime':
          return filterByNestedMultiSelect(filterParams, flightFilterParams === null || flightFilterParams === void 0 ? void 0 : flightFilterParams.departureTime);
        case 'arrivalTime':
          return filterByNestedMultiSelect(filterParams, flightFilterParams === null || flightFilterParams === void 0 ? void 0 : flightFilterParams.arrivalTime);
        case 'insuranceOnly':
          return filterByInsuranceOnly(filterParams, flightFilterParams === null || flightFilterParams === void 0 ? void 0 : flightFilterParams.insuranceOnly);
        case 'hasBaggageOnly':
          return filterByHasBaggage(filterParams, flightFilterParams === null || flightFilterParams === void 0 ? void 0 : flightFilterParams.hasBaggageOnly, flightFareFamilies);
        case 'isFlex':
          return filterByFlexibility(filterParams, flightFilterParams === null || flightFilterParams === void 0 ? void 0 : flightFilterParams.airline);
        default:
          return true;
      }
    });
  });
}
function filterByMultiSelect(filterParams, flightFilterParams) {
  if ((0, _isEmpty2.default)(filterParams)) return true;
  return (0, _includes2.default)(filterParams, flightFilterParams);
}
function filterByNestedMultiSelect(filterParams, flightFilterParams) {
  return (0, _every2.default)(filterParams, function (legFilterParams, legIndex) {
    return filterByMultiSelect(legFilterParams, flightFilterParams[legIndex]);
  });
}
function filterByAirline(filterParams, flightFilterParams) {
  if ((0, _isEmpty2.default)(filterParams)) return true;
  return (0, _every2.default)(flightFilterParams, function (legFilterParams) {
    return (0, _includes2.default)(filterParams, legFilterParams);
  });
}
function filterByHasBaggage(hasBaggageOnly, flightHasBaggage, flightFareFamilies) {
  return hasBaggageOnly && !flightFareFamilies ? flightHasBaggage : true;
}
function filterByFlexibility(isFlex, airlines) {
  var isFlexFlight = !(0, _isEmpty2.default)((0, _intersection2.default)(_constants.FLEX_AIRLINES, airlines));
  return isFlex ? isFlexFlight : true;
}
function filterByInsuranceOnly(insuranceOnly, flightInsuranceOnly) {
  var insuranceExpired = !(0, _itinerary.checkValidInsuranceDate)();
  if (!insuranceOnly || insuranceExpired) return true;
  if (insuranceOnly) return flightInsuranceOnly;
}
function filterByAirport(filterParam, flightFilterParams) {
  return (0, _every2.default)(filterParam, function (legFilterParam, legIndex) {
    var origin = legFilterParam.origin,
      destination = legFilterParam.destination;
    var _split2 = (0, _split3.default)(flightFilterParams[legIndex], _constants.FILTER_PARAM_AIRPORT_SEPARATOR),
      originId = _split2[0],
      destinationId = _split2[1];
    var isValidOrigin = filterByMultiSelect(origin, originId);
    var isValidDestination = filterByMultiSelect(destination, destinationId);
    return isValidOrigin && isValidDestination;
  });
}
function filterByPrice(_ref2, flightFilterParams) {
  var from = _ref2.from,
    to = _ref2.to;
  return from <= flightFilterParams && to >= flightFilterParams;
}
function mergeFilterState(filterState) {
  var mergedFilterState = {};
  (0, _each2.default)(filterState, function (legFilterState) {
    (0, _each2.default)(legFilterState, function (filterItem) {
      var code = filterItem === null || filterItem === void 0 ? void 0 : filterItem.code;
      var selected = filterItem === null || filterItem === void 0 ? void 0 : filterItem.selected;
      if (!mergedFilterState[code] || selected) {
        mergedFilterState[code] = filterItem;
      }
    });
  });
  return Object.values(mergedFilterState);
}
function getDisplayPriceFilterState(priceFilterState, $currency) {
  if (!(0, _isPlainObject2.default)(priceFilterState)) return priceFilterState;
  var displayPriceFilterState = _objectSpread(_objectSpread({}, priceFilterState), {}, {
    currency: $currency.currentCurrency
  });
  (0, _each2.default)(priceFilterState, function (value, key) {
    displayPriceFilterState["display" + (0, _capitalize2.default)(key)] = $currency.formatPriceWithDecimals(value, 0);
  });
  return displayPriceFilterState;
}
function generateFilterId(filterInfo) {
  var key = filterInfo.key,
    code = filterInfo.code,
    index = filterInfo.index,
    type = filterInfo.type;
  var id = key;
  id += index !== undefined ? "_" + index : '';
  id += type !== undefined ? "_" + type : '';
  id += code !== undefined ? "_" + code : '';
  return id;
}
var _default = exports.default = {
  execute: filter,
  extractData: _filterData.default,
  extractParams: _filterParams.extractFilterParams,
  extractAllParams: _filterParams.default,
  extractQuery: _filterQuery.extractFilterQuery,
  extractAllQuery: _filterQuery.default,
  initialize: _filterInitialize.initializeFilterState,
  initializeSub: _filterInitialize.initializeSubFilterState,
  initializeAll: _filterInitialize.default,
  update: _filterUpdate.default.updateFilterState,
  updateAll: _filterUpdate.default.updateAllFiltersState,
  updateRange: _filterUpdate.default.updateFilterStateRange,
  toggle: _filterUpdate.default.toggleFilterItemState,
  toggleAll: _filterUpdate.default.toggleAllFilterItemsState,
  set: _filterUpdate.default.setFilterItemState,
  setAll: _filterUpdate.default.setAllFilterItemsState,
  checkReset: _filterCheck.default.checkFilterStateReset,
  checkFilterReset: _filterCheck.default.checkSubFilterStateReset,
  checkSelected: _filterCheck.default.checkFilterItemSelected,
  checkAllSelected: _filterCheck.default.checkAllFilterItemsSelected,
  merge: mergeFilterState,
  getAppliedFilters: _filterApplied.default,
  getAvailableAppliedFilters: _filterApplied.getAvailableAppliedFilters,
  getDisplayPriceFilterState: getDisplayPriceFilterState
};